<template>
	<div class="container whoAmIOptions">
		<h2 class="form-signin-heading" aria-hidden="false">
			Sign in to your account
		</h2>
		<b-form @submit.prevent="login()">
			<b-alert :show="isError" variant="danger"
				>{{ this.errorMessage }}
			</b-alert>
			<b-form-group
				id="emailGroup"
				label="Enter your email"
				label-for="email"
				label-class="hidden"
				:state="emailState"
				:invalid-feedback="emailInvalidFeedback"
			>
				<b-form-row>
					<b-form-input
						id="email"
						type="email"
						:state="emailState"
						v-model.trim="email"
						class="form-control"
						name="email"
						required
						v-focus
						placeholder="email@example.com"
					></b-form-input>
				</b-form-row>
			</b-form-group>
			<b-form-group
				id="passwordGroup"
				label="Enter your password"
				label-for="password"
				label-class="hidden"
				:state="passwordState"
				:invalid-feedback="passwordInvalidFeedback"
			>
				<b-form-row>
					<b-form-input
						id="password"
						type="password"
						:state="passwordState"
						v-model.trim="password"
						class="form-control"
						name="password"
						required
						placeholder="Password"
					></b-form-input>
				</b-form-row>
			</b-form-group>
			<b-form-row>
				<b-col>
					<b-button :disabled="formValid" type="submit" variant="primary"
						>Login
					</b-button>
				</b-col>
				<b-col>
					<b-button
						variant="secondary"
						size="sm"
						class="formSubmit float-right"
						@click="cancel_click()"
					>
						Cancel
					</b-button>
				</b-col>
			</b-form-row>
			<b-row>
				<b-btn
					variant="link"
					:disabled="forgot_submitted || !isValidEmail()"
					@click.prevent="forgot_password"
				>
					Forgot Password?
				</b-btn>
			</b-row>
		</b-form>
	</div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	name: "Login",
	data: function() {
		return {
			email: null,
			password: null,
			errorMessage: null,
			forgot_submitted: false
		};
	},
	methods: {
		isValidEmail: function() {
			return this.email !== "" && this.validEmail(this.email);
		},
		login: function() {
			this.$store.dispatch("login_to_server", {
				email: this.email.toLowerCase(),
				password: this.password
			});
		},
		forgot_password: function() {
			this.forgot_submitted = true;
			this.$store.dispatch("forgot_password", this.email.toLowerCase());
		},
		cancel_click() {
			this.$router.push("/intro");
		}
	},
	computed: {
		...mapGetters(["userType"]),
		formValid() {
			return !(
				this.email &&
				this.email.length > 0 &&
				this.validEmail(this.email) &&
				this.isValidPassword
			);
		},
		isValidPassword() {
			return this.password && this.password.length > 0;
		},
		isError() {
			return this.errorMessage !== null;
		},
		emailState() {
			if (this.email === null) {
				return null;
			}
			return this.email !== "" && this.validEmail(this.email);
		},
		emailInvalidFeedback() {
			if (this.email === null) {
				return "";
			}
			if (this.validEmail(this.email)) {
				return "";
			}
			return "Invalid email";
		},
		passwordState() {
			if (!this.seenPassword) {
				return null;
			}
			return this.password !== "";
		},
		passwordInvalidFeedback() {
			if (!this.seenPassword) {
				return "";
			}
			if (this.password === "") {
				return "Password is required";
			}
			return "";
		}
	},
	watch: {
		userType(value) {
			if (value === "authed") {
				this.$router.push("/applications");
			}
		}
	}
};
</script>

<style scoped>
.formSubmit {
	margin: 0 auto;
}
</style>
